import React from 'react'

export const QueuesContext = React.createContext()

export function QueuesContextProvider({ value, children }) {
  return <QueuesContext.Provider value={value}>{children}</QueuesContext.Provider>
}
